import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./MangaCard.css"; 
import LazyImage from "./LazyImage"; // Import the LazyImage component
import "./LazyImage.css"; // Import the LazyImage styles

const MangaCard = ({ manga, layout = "horizontal" }) => {
  // Keep only the cardRef hook, remove useState and useEffect
  const cardRef = useRef(null);
  
  // Validation checks after all hooks
  if (!manga || typeof manga !== 'object') {
    console.error("Invalid manga object provided to MangaCard:", manga);
    return <div className="manga-card error-card">Invalid manga data</div>;
  }

  // More flexible ID handling - can be _id, id, or mal_id
  const mangaId = manga.id || manga.mal_id || 'unknown';
  
  // If we don't have an ID at all, still try to render but with a warning
  if (mangaId === 'unknown') {
    console.warn("Manga card missing ID property:", manga);
  }

  // Handle null or undefined values with clean fallbacks
  const score = manga.score ?? 0;
  const chapters = manga.chapters ?? "-";
  const volumes = manga.volumes ?? "-";
  const status = manga.status ?? "N/A";
  const type = manga.type ?? "N/A";
  const rank = manga.rank ?? "N/A";
  const popularity = manga.popularity ?? "N/A";
  
  // Get demographic if available - with proper null checking
  const demographic = manga.demographics && Array.isArray(manga.demographics) && manga.demographics.length > 0 
    ? manga.demographics[0].name 
    : null;
  
  // Get serialization if available - with proper null checking
  const serialization = manga.serializations && Array.isArray(manga.serializations) && manga.serializations.length > 0
    ? manga.serializations[0].name
    : null;

  // Get image with fallback
  const imageUrl = manga.images?.webp?.large_image_url || 
                   manga.images?.jpg?.large_image_url || 
                   manga.images?.webp?.image_url || 
                   manga.image || 
                   '/default-manga.jpg';

  // Always use horizontal layout
  const cardClass = "manga-card card-horizontal";

  return (
    <div className={cardClass} ref={cardRef}>
      <Link to={`/manga/${mangaId}`} className="card-link">
        <div className="card-image-container">
          {/* Replace img with LazyImage */}
          <LazyImage
            src={imageUrl}
            alt={manga.title_english || "Manga"}
            className="card-image"
            fallbackSrc="/default-manga.jpg"
          />
          <div className="rating-badge">
            ⭐ {score}
          </div>
          
          {/* Show demographic as a badge if available */}
          {/* {demographic && demographic !== "Adult" && (
            <div className="demographic-badge" title={demographic}>
              {demographic}
            </div>
          )} */}
        </div>

        <div className="card-content">
          <div className="metadata-content">
            <h3 className="card-title">{manga.titleEnglish || manga.title || "Unknown Title"}</h3>
            
            <div className="metadata-line">
              <span className="metadata-item">
                <span className="metadata-label">Type:</span> 
                <span className="metadata-value">{type}</span>
              </span>
              <span className="metadata-divider">•</span>
              <span className="metadata-item">
                <span className="metadata-label">Chapters:</span> 
                <span className="metadata-value">{chapters}</span>
              </span>
            </div>

            {/* Add mobile-hide class to hide on small screens */}
            <div className="metadata-line mobile-hide">
              <span className="metadata-item">
                <span className="metadata-label">Status:</span> 
                <span className={`metadata-value ${status === 'Publishing' ? 'live-status' : ''}`}>
                  {status}
                </span>
              </span>
              {volumes !== "-" && (
                <>
                  <span className="metadata-divider">•</span>
                  <span className="metadata-item">
                    <span className="metadata-label">Volumes:</span> 
                    <span className="metadata-value">{volumes}</span>
                  </span>
                </>
              )}
            </div>
          </div>

          {/* Add mobile-hide class to hide on small screens */}
          <div className="metadata-footer mobile-hide">
            <span className="rank-badge">Rank #{rank}</span>
            <span className="popularity-badge">Popularity #{popularity}</span>
            {serialization && (
              <span className="serialization-badge">{serialization}</span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MangaCard;